<template>
  <div>
    <van-nav-bar
      title="持仓查询"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-list
      v-model="loadingPosition"
      :finished="finishedPosition"
      finished-text="没有更多了"
    >
      <div class="tableContent">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr class="tableheading">
            <th>合约号</th>
            <th>名称代码</th>
            <th>总持仓数</th>
            <th>可卖数量</th>
            <th>冻结数量</th>
            <th>成本价</th>
            <th>当前价</th>
            <th>浮动盈亏</th>
            <th>持仓市值</th>
            <th>多头/空头</th>
            <th>开仓日</th>
          </tr>
          <tr class="stock_td" v-for="(item, index) in all_depot" :key="index">
            <td>
              <p>{{ item.order }}</p>
            </td>
            <td>
              <p>
                <span
                  style="
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  "
                  >{{ item.name }}</span
                ><br /><span>{{ item.short }}</span>
              </p>
            </td>
            <td>
              <p>{{ item.number }}</p>
            </td>
            <td>
              <p>{{ item.surplus }}</p>
            </td>
            <td>
              <p>{{ item.frozen }}</p>
            </td>
            <td>
              <p v-bind:class="[item.price >= 0 ? 'redText' : 'greenText']">{{ parseFloat(item.price).toFixed(3) }}</p>
            </td>
            <td>
              <p>{{ item.newPrice.toFixed(3) }}</p>
            </td>
            <td>
              <p v-bind:class="[item.price >= 0 ? 'redText' : 'greenText']">
                {{ item.profitPrice }}%
              </p>
            </td>
            <td>
              <p>
                {{ (item.number * item.newPrice).toFixed(2) }}
              </p>
            </td>
            <td>
              <p>{{ item.direction }}</p>
            </td>
            <td>
              <p>{{ item.time }}</p>
            </td>
          </tr>
        </table>
      </div>
    </van-list>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "PositionInquiry",
  data() {
    return {
      all_depot: [],
      loadingPosition: false,
      finishedPosition: false,
    };
  },

  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getAllDepot() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_depot",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            let dataArr = resData.data;
            if (dataArr.length != 0) {
              let shortArr = [];
              $.each(dataArr, function (index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
            } else if (dataArr.length == 0) {
              that.loadingPosition = false;
              that.finishedPosition = true;
            } else {
              that.all_depot = resData.data;
            }
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingPosition = false;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    getNewPrice(shortArr, dataArr) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "shuhai_price",
            code: shortArr.toString(),
            withcode: 0,
          },
        })
        .then((res) => {
          var stockData = res.data.data;

          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = stockData.find(
              (o) => o.Symbol === shortArr[i].toUpperCase()
            );
            dataArr[i]["newPrice"] = elements["NewPrice"]; //当前价
            var newPrice = parseFloat(elements["NewPrice"]); //当前价
            var number = parseFloat(dataArr[i].number); //持有股数
            var costPrice = parseFloat(dataArr[i].price); //成本价
            // var profitPrice = ((newPrice - costPrice) / costPrice * 100).toFixed(2); //盈亏金额
            var costtotal = parseFloat(dataArr[i].costtotal);
            var profitPrice = ((newPrice*number) - costtotal).toFixed(2);
            var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
            var market = (newPrice * number).toFixed(2); //当前市值
            priceRatio = priceRatio.toFixed(2);
            dataArr[i]["profitPrice"] = profitPrice;
            dataArr[i]["priceRatio"] = priceRatio;
            dataArr[i]["market"] = market;
          }
          that.all_depot = dataArr;
          that.loadingPosition = false;
          that.finishedPosition = true;
        });
      // $.ajax({
      //   url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
      //   type: "GET",
      //   dataType: "script",
      //   cache: true,
      //   success: function () {
      //     var i, elements;
      //     for (i = 0; i < shortArr.length; i++) {
      //       var elements = eval("v_" + shortArr[i]).split("~");
      //       dataArr[i]["newPrice"] = elements[3]; //当前价
      //       var newPrice = parseFloat(elements[3]); //当前价
      //       var number = parseFloat(dataArr[i].number); //持有股数
      //       var costPrice = parseFloat(dataArr[i].price); //成本价
      //       var profitPrice = ((newPrice - costPrice) * 100).toFixed(2); //盈亏金额
      //       var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
      //       var market = (newPrice * number).toFixed(2); //当前市值
      //       priceRatio = priceRatio.toFixed(2);
      //       dataArr[i]["profitPrice"] = profitPrice;
      //       dataArr[i]["priceRatio"] = priceRatio;
      //       dataArr[i]["market"] = market;
      //     }
      //     that.all_depot = dataArr;
      //     that.loadingPosition = false;
      //     that.finishedPosition = true;
      //   },
      // });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getAllDepot();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.tableheading {
  font-size: 14px;
  /* position: sticky;
  top: 46px; */
  padding-bottom: 10px;
  text-align: center;
  background: #ffffff;
  height: 45px;
  line-height: 45px;
}
.stockTable {
  text-align: left;
  width: 800px;
  padding: 0px 10px;
  font-size: 14px;
}

.stockTable th,
.stockTable td {
  width: 80px;
  text-align: center;
}

.stock_td p {
  margin: 5px 0px;
}

.tableContent {
  margin-top: 10px;
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100vw;
}

.redText {
  color: red;
}
.greenText {
  color: #008000;
}
</style>


// WEBPACK FOOTER //
// src/components/PositionInquiry.vue